module.exports = __webpack_public_path__ + "static/ywbl2-690481ea2ea91788d9edb050055ec110.jpg";